import { HttpCacheTypes } from "../types";
import { createAction } from "./create.action";

export namespace HttpCacheAction {

    export const addCache = (url: string, response: any, expiry: number) => createAction(HttpCacheTypes.ADD_HTTP_CACHE, { key: url, value: response, expiry });
    export const removeCache = (key: string) => createAction(HttpCacheTypes.REMOVE_HTTP_CACHE, key);
    export const cleanUp = () => createAction(HttpCacheTypes.CLEAN_UP_HTTP_CHACHE);

}